module.exports = __webpack_public_path__ + "static/media/CB_engagement_19.032fb71b.jpg";